import React, { useState, useEffect } from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';

import css from './CustomAmenityModal.module.css';

const CustomAmenityModal = props => {
  const {
    isOpen,
    onClose,
    onSave,
    onCancel,
    error,
    className,
    rootClassName,
  } = props;

  const [amenityName, setAmenityName] = useState('');
  const [localError, setLocalError] = useState(null);

  // Update local error when prop error changes
  useEffect(() => {
    setLocalError(error);
  }, [error]);

  const handleNameChange = e => {
    const value = e.target.value;
    // Limit to 30 characters
    if (value.length <= 30) {
      setAmenityName(value);
      // Clear error when user starts typing
      if (localError) {
        setLocalError(null);
      }
    }
  };

  const handleSave = () => {
    const trimmedName = amenityName.trim();
    
    // if (!trimmedName) {
    //   setLocalError('Please enter an amenity name');
    //   return;
    // }

    onSave(trimmedName);
    setAmenityName('');
    setLocalError(null);
  };

  const handleCancel = () => {
    setAmenityName('');
    setLocalError(null);
    onCancel();
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  const classes = classNames(rootClassName || css.root, className);
  const characterCount = amenityName.length;

  return (
    <Modal
      id="CustomAmenityModal"
      isOpen={isOpen}
      onClose={handleCancel}
      usePortal
      // containerClassName={css.modalContainer}
      // contentClassName={css.modalContent}
      onManageDisableScrolling={()=>{}}
      className={css.otherHomeTypeModal}
    >
      <div className={classes}>
        <div className={css.modalHeader}>
          <h2 className={css.title}>Custom amenity</h2>
          <button
            type="button"
            className={css.modalClose}
            onClick={handleCancel}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1 1L14.3333 14.3333M1 14.3333L14.3333 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className={css.inputGroup}>
          <label htmlFor="amenityName" className={css.label}>
            Amenity name
          </label>
          <input
            id="amenityName"
            type="text"
            className={classNames(css.input, {
              [css.inputError]: localError,
            })}
            value={amenityName}
            onChange={handleNameChange}
            onKeyDown={handleKeyDown}
            placeholder=""
            maxLength={30}
            autoFocus
          />
          <div className={css.characterCount}>
            {characterCount}/30 characters
          </div>
          {localError && (
            <span className={css.errorText} role="alert">
              {localError}
            </span>
          )}
        </div>

        <div className={css.buttonGroup}>
          <PrimaryButton onClick={handleSave} className={css.saveButton}>
            Add Amenity
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

CustomAmenityModal.defaultProps = {
  isOpen: false,
  error: null,
  className: null,
  rootClassName: null,
};

CustomAmenityModal.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  onSave: func.isRequired,
  onCancel: func.isRequired,
  error: string,
  className: string,
  rootClassName: string,
};

export default CustomAmenityModal;
